import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private dataStore: { [key: string]: any } = {}; // Internal key-value store

  constructor() {}

  // Set a value for a key
  set(key: string, value: any): void {
    this.dataStore[key] = value;
  }

  // Get a value by key
  get<T>(key: string): T | null {
    return this.dataStore[key] !== undefined ? this.dataStore[key] : null;
  }

  // Remove a key-value pair
  remove(key: string): void {
    delete this.dataStore[key];
  }

  // Clear all stored data
  clear(): void {
    this.dataStore = {};
  }
}